import { MfeReactComponent } from '@carvana/microfrontend-react';
import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Loading from '|/components/base/loading';
import { DevicePlatformContext } from '|/context';
import PurchaseContext from '|/context/purchase-context';
import { loadOpdMfe } from '|/hooks/use-global-mfe-config';
import useNavigateAwayFromPurchase from '|/hooks/use-navigate-away-from-purchase';
import useNavigateInPurchase from '|/hooks/use-navigate-in-purchase';

const OpdMfeRoute: React.FC = () => {
  const { pathname } = useLocation();
  const { vehicleId } = useContext(PurchaseContext);
  const devicePlatform = useContext(DevicePlatformContext);
  const navigateInPurchase = useNavigateInPurchase();
  const navigateAwayFromPurchase = useNavigateAwayFromPurchase();

  useEffect(() => {
    loadOpdMfe();
  }, []);

  return (
    <MfeReactComponent
      module="OrderPlacedDashboardModule"
      component="default"
      currentPath={pathname}
      vehicleId={vehicleId}
      devicePlatform={devicePlatform}
      onNavigateInPurchase={navigateInPurchase}
      onNavigateAwayFromPurchase={navigateAwayFromPurchase}
      loading={<Loading />}
      onComponentError={({ id, error }: { id: string; error?: Error }) => {
        throw new Error(`OPD MFE component failed: ${id}`, { cause: error });
      }}
    />
  );
};

export default OpdMfeRoute;
